import { AxiosInstance } from "axios";
import { ApiService } from "../model/Api.model";
import { IPricingBidReportGetByPeriodRequest } from "../interface/report/IPricingBidReportGetByPeriodRequest";
import { IPricingBidReportProcessByPeriodRequest } from "../interface/report/IPricingBidReportProcessByPeriodRequest";


enum PricingBidReportServiceEnum {
  processbyperiod = "/processbyperiod",
  getbyperiod = "/getbyperiod"
}

export default class PricingBidReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/pricing/bid");
  }

  public getbyperiod = async (dtStart: string, dtEnd: string): Promise<IPricingBidReportGetByPeriodRequest> => await this.GET(`${PricingBidReportServiceEnum.getbyperiod}?dtStart=${dtStart}&dtEnd=${dtEnd}`);
  public processbyperiod = async (data: any): Promise<IPricingBidReportProcessByPeriodRequest> => await this.POST(`${PricingBidReportServiceEnum.processbyperiod}`, data);

}


// WEBPACK FOOTER //
// ./src/services/api/PricingBidReport.service.ts